// Fraud Detection Configuration
// These values can be adjusted by operations team without code changes

export const FRAUD_DETECTION_CONFIG = {
  // Rule thresholds (adjusted for less false positives)
  rules: {
    NO_MOVE_BIG_FILL_L: 60,        // Liters threshold for big fill without movement (raised from 50)
    SHORT_HOP_BIG_FILL_L: 70,      // Liters threshold for big fill after short distance
    SHORT_HOP_KM: 30,              // Distance threshold for short hop
    SAME_STATION_EPS: 1e-4,        // Coordinate epsilon for same station (~11m)
    ODO_MIN_DELTA_KM: 30,          // Minimum odometer delta for big fills
    MAX_FILLS_PER_24H: 3,          // Maximum fills per 24 hours (raised from 2)
    SMALL_L_THRESH: 20,            // Small fill threshold in liters
    SMALL_FILL_MIN_COUNT_24H: 3,   // Minimum small fills in 24h to flag
    SMALL_FILL_MIN_SUM_24H: 60,    // Minimum sum of small fills in 24h to flag (both conditions required)
    EFF_RATIO_MIN: 0.4             // Minimum efficiency ratio (40% of expected, lowered from 50%)
  },

  // Default vehicle parameters
  defaults: {
    EFFICIENCY_KM_PER_L: 3.0,      // Default fuel efficiency
    TANK_CAPACITY_L: 200,          // Default tank capacity
    INITIAL_FUEL_RATIO: 0.5        // Start with half tank estimate
  },

  // Fraud rule weights for scoring
  weights: {
    NO_MOVE_BIG_FILL: 5,           // High priority
    SHORT_HOP_BIG_FILL: 5,         // High priority
    ODOMETER_ANOMALY: 5,           // High priority
    TANK_OVERFLOW_MATH: 5,         // High priority
    IMPOSSIBLE_EFFICIENCY: 3,       // Medium priority
    SMALL_FILLS_FREQUENT_24H: 2,   // Low priority
    SMALL_FILLS_ACCUMULATE_24H: 2, // Low priority
    SMALL_FILLS_SAME_STATION: 2,   // Low priority
    FILL_FREQUENCY_SPIKE_24H: 2    // Low priority
  },

  // Geocoding settings
  geocoding: {
    COORDINATE_PRECISION: 4,       // Decimal places for coordinate rounding
    CACHE_EXPIRY_DAYS: 30,        // How long to cache geocoding results
    RATE_LIMIT_MS: 1000           // Rate limit for Nominatim (1 request per second)
  },

  // Display settings
  display: {
    SCORE_COLORS: {
      HIGH: 'bg-red-100 text-red-800 border-red-200',      // Score >= 5
      MEDIUM: 'bg-orange-100 text-orange-800 border-orange-200', // Score >= 3
      LOW: 'bg-amber-100 text-amber-800 border-amber-200',    // Score > 0
      NONE: 'bg-gray-100 text-gray-800 border-gray-200'          // Score = 0
    },
    
    FLAG_NAMES_AR: {
      'NO_MOVE_BIG_FILL': 'تعبئة كبيرة بدون حركة',
      'SHORT_HOP_BIG_FILL': 'تعبئة كبيرة مسافة قصيرة',
      'ODOMETER_ANOMALY': 'خلل في العداد',
      'IMPOSSIBLE_EFFICIENCY': 'كفاءة مستحيلة',
      'TANK_OVERFLOW_MATH': 'تجاوز سعة الخزان',
      'SMALL_FILLS_FREQUENT_24H': 'تعبئات صغيرة متكررة',
      'SMALL_FILLS_ACCUMULATE_24H': 'تراكم تعبئات صغيرة',
      'SMALL_FILLS_SAME_STATION': 'تعبئات صغيرة نفس المحطة',
      'FILL_FREQUENCY_SPIKE_24H': 'ارتفاع تكرار التعبئة'
    }
  }
};

// Helper function to get configuration value with fallback
export function getConfigValue(path, fallback = null) {
  const keys = path.split('.');
  let value = FRAUD_DETECTION_CONFIG;
  
  for (const key of keys) {
    if (value && typeof value === 'object' && key in value) {
      value = value[key];
    } else {
      return fallback;
    }
  }
  
  return value;
}

// Helper function to update configuration (for future admin interface)
export function updateConfigValue(path, newValue) {
  const keys = path.split('.');
  const lastKey = keys.pop();
  let target = FRAUD_DETECTION_CONFIG;
  
  for (const key of keys) {
    if (!(key in target)) {
      target[key] = {};
    }
    target = target[key];
  }
  
  target[lastKey] = newValue;
}

export default FRAUD_DETECTION_CONFIG;